<template>
  <div class="label-container">
    <van-tag round v-for="(item, index) in list" :key="index" class="tag" @click="doChoose(item)">{{ item }}</van-tag>
  </div>
</template>
<script>
import { getTopLabels } from "@/api/business";
export default {
  name: "TopLabels",
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getTopLabels();
  },
  methods: {
    async getTopLabels() {
      let { status, resultData } = await getTopLabels();
      if (status === "complete") {
        if (resultData) {
          this.list = resultData;
        }
      }
    },
    doChoose(item) {
      this.$emit("handle-choose", item);
    }
  }
};
</script>
<style lang="less" scoped>
.label-container {
  width: 100%;
  justify-content: space-between;
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }

  .tag {
    margin: 0px 8px;
  }
  .van-tag {
    background: #fff;
    color: #797979;
    padding: 4px 10px;
  }
}
</style>
